<template>
  <el-tooltip content="添加词条">
    <img class="func-img" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/create.png" @click="onClick" />
  </el-tooltip>

</template>

<script>
export default {
  name: 'BoldMenuButton',

  props: ['isActive'],

  methods: {
    onClick (e) {
      this.$emit('click', (arr, callback) => {
        this.$parent.$parent.$parent.$emit('addCreated', arr, callback)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.func-img{
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 8px;
}
</style>
